import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ParadigmSection from '../components/ParadigmSection';
import ArchitectureSection from '../components/ArchitectureSection';
import DarkSectorSection from '../components/DarkSectorSection';
import OmegaSection from '../components/OmegaSection';
import ProofSection from '../components/ProofSection';
import ImplicationsSection from '../components/ImplicationsSection';
import Footer from '../components/Footer';
import WaitlistModal from '../components/WaitlistModal';

const HomePage = () => {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);

  return (
    <div style={{ background: '#000000', minHeight: '100vh' }}>
      <Header />
      <HeroSection onDownloadClick={() => setIsWaitlistOpen(true)} />
      <ParadigmSection />
      <ArchitectureSection />
      <DarkSectorSection />
      <OmegaSection />
      <ProofSection />
      <ImplicationsSection />
      <Footer onDownloadClick={() => setIsWaitlistOpen(true)} />
      <WaitlistModal 
        isOpen={isWaitlistOpen} 
        onClose={() => setIsWaitlistOpen(false)} 
      />
    </div>
  );
};

export default HomePage;